import React from "react";
import connect from "Shared/connect";
import Modal from "Shared/Modal";
import Button from "Shared/Button";
import * as styles from "./base.scss";
import { translate } from "Shared/translate";
class MfaModal extends React.Component {
    constructor(props) {
        super(props);
        this.closeInfoModal = () => {
            this.setState({ isOpen: false });
        };
        this.confirmInfoModal = () => {
            window.open(this.props.oktaActivateOktaMfaUrl, "_blank");
            this.setState({ isOpen: false });
        };
        this.state = {
            isOpen: true,
        };
    }
    componentDidMount() { }
    render() {
        return (React.createElement(Modal, { onClose: this.closeInfoModal, isOpen: this.state.isOpen },
            React.createElement("h2", null, translate("/Shared/MfaHeader")),
            React.createElement("div", { dangerouslySetInnerHTML: { __html: this.props.mfaModalContent } }),
            React.createElement("div", { className: styles.base },
                React.createElement("div", { className: styles.buttonWrap },
                    React.createElement(Button, { className: styles.buttonSkip, appearance: "monochrome", onClick: this.closeInfoModal }, translate("/Shared/Skip"))),
                React.createElement("div", { className: styles.buttonWrap },
                    React.createElement(Button, { className: styles.button, appearance: "primary", onClick: this.confirmInfoModal }, translate("/Shared/Activate"))))));
    }
}
export default connect((state) => ({
    oktaActivateOktaMfaUrl: state.appShellData.siteSettings.oktaActivateOktaMfaUrl,
    mfaModalContent: state.appShellData.siteSettings.mfaModalContent,
}))(MfaModal);
